export type AIChatRole = 'user' | 'system' | 'assistant' | 'tool';

export interface AIChatAttachment {
  file_id: string;
  tools: [{ type: string }];
}

export type AIChatInputToolType = 'file_search';

export interface AIChatInputTool {
  type: AIChatInputToolType;
  vector_store_ids: string[];
  max_num_results?: number;
}

export interface AIChatInput {
  role?: AIChatRole;
  content?: AIChatInputContent[] | string;
  files?: AIChatFile[];
  type?: string;
  call_id?: string;
  output?: string;
}

export type AIChatInputContentType = 'input_text' | 'input_image';

export interface AIChatInputContent {
  type: AIChatInputContentType;
  text?: string;
  image_url?: string;
}

export interface AIChatToolCall {
  arguments: string;
  call_id: string;
  id: string;
  name: string;
  status: string;
  type: string;
}

export interface AIChatFile {
  size: number;
  name: string;
  fileId: string;
  vectorStoreId: string;
}

export interface AIChatIdea {
  icon: any;
  title: string;
  requests: string[];
}

export enum AI_MODEL {
  GPT_5_1 = 'gpt-5.1',
  GPT_4O = 'gpt-4o',
  GPT_4O_MINI = 'gpt-4o-mini',
  GPT_3_5_TURBO = 'gpt-3.5-turbo',
}

// What the chat shows. The transcript sent to the model (AIChatInput[]) is kept
// separately, since it also carries function calls and their outputs.
export interface LailaTextBlock {
  type: 'text';
  text: string;
}

// Something a tool had to show, e.g. an invite to check and send. `kind`
// picks how it is drawn; `data` is that kind's own shape.
export interface LailaCardBlock {
  type: 'card';
  id: string;
  kind: string;
  data: Record<string, unknown>;
}

export type LailaBlock = LailaTextBlock | LailaCardBlock;

export interface LailaMessage {
  id: string;
  role: 'user' | 'assistant';
  blocks: LailaBlock[];
  files?: AIChatFile[];
  createdAt: number;
  // A user message whose answer failed; the chat offers to retry it.
  failed?: boolean;
}
